import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import step8Img from "@/assets/img/cfd-guide/guide1.png";
import lineImg from "@/assets/img/cfd-guide/line.png";
import { useCfdGuideStageRect } from "./useCfdGuideStageRect";
import { useCfdGuideAnchoredTipLayout } from "./useCfdGuideAnchoredTipLayout";
import styles from "./ProGuideStep8.module.scss";

const { useTranslation } = Hooks;

export type ProGuideStep8Props = {
  onSkip: () => void;
  onNext: () => void;
};

const DESIGN_WIDTH = 375;

function getScale(): number {
  if (typeof window === "undefined") return 1;
  const w = window.innerWidth || DESIGN_WIDTH;
  return w / DESIGN_WIDTH;
}

const ProGuideStep8: React.FC<ProGuideStep8Props> = ({ onSkip, onNext }) => {
  const t = useTranslation();

  const scale = getScale();
  const anchor = useCfdGuideStageRect('[data-guide-target="positionListTabs"]');
  const tipLayout = useCfdGuideAnchoredTipLayout(anchor, scale);

  const imgSrc = (step8Img as any)?.src || (step8Img as any);
  const lineImgSrc = (lineImg as any)?.src || (lineImg as any);

  return (
    <div style={{ ["--sg-scale" as any]: scale }}>
      {anchor && tipLayout ? (
        <>
          <div
            className={styles.highlightRect}
            style={{
              position: "fixed",
              left: anchor.left,
              top: anchor.top,
              width: anchor.width,
              height: anchor.height,
              zIndex: 10001,
            }}
          >
            <div className={styles.tabs}>
              <div className={`${styles.tab} ${styles.active}`}>
                <span className={styles.tabText}>{t("cfd.currentPositions")}(1)</span>
                <div className={styles.tabIndicator} />
              </div>
              <div className={styles.tab}>
                <span className={styles.tabText}>{t("cfd.currentOrders")}(1)</span>
              </div>
            </div>
          </div>

          <div
            className={styles.tip}
            style={{
              position: "fixed",
              left: tipLayout.tipLeft,
              top: anchor.top + anchor.height + tipLayout.gapBelow,
              width: tipLayout.tipWidth,
              zIndex: 10001,
            }}
          >
            <div className={styles.tipBg}>
              <div className={styles.tipText}>
                <div className={styles.tipTitle}>{t("cfd.guide.pro.step8.title")}</div>
                <div className={styles.tipDesc}>{t("cfd.guide.pro.step8.desc")}</div>
              </div>
              <img className={styles.tipImg} src={imgSrc} alt="" />
            </div>
            <div className={styles.star1} />
            <div className={styles.star2} />
            <img
              className={styles.lineImg}
              src={lineImgSrc}
              alt=""
              style={{
                left: tipLayout.lineCenterInTip,
                transform: "translateX(-50%)",
              }}
            />
          </div>
        </>
      ) : null}

      <div className={styles.btnGroup}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onNext}>
          {`${t("cfd.guide.next")} 8/9`}
        </button>
        <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onSkip}>
          {t("cfd.guide.skip")}
        </button>
      </div>
    </div>
  );
};

export default observer(ProGuideStep8);
